<template>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Omiljeni saloni</h3>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 salon-container mb-3">
					<div class="container">
						<div class="row no-gutters">
							<div class="col-12" v-if="loadingFavorite">
								<loader color='red'></loader>
							</div>
								<div v-for="(favorite,index) in favorites" :key="index" class="col-12 rezervacije-div">
										<div class="rezervacije-left">
											<p class="rezervacije-bold"><span class="mr-2"><i class="far fa-heart primary-color"></i></span>{{favorite.name}}</p>
											<div class="komentar-username">{{favorite.address}}</div>
										</div>
										<div class="rezervacije-right">
											<div class="rezervacije-btns">
												<a :href="'/salon/'+favorite.name" class="btn fs-btn dark small ml-2"><span class="fas fa-external-link-alt"></span></a>
												<a @click="delFavorite(favorite.id)" class="btn fs-btn danger-border small ml-2"><span class="far fa-trash-alt"></span></a>
											</div>
										</div>
								</div>
								<!-- <p v-if="favorites.length == 0">Trenutno nemate omiljene salone.</p> -->
							<div v-if="last_page > 1" class="col-12">
								<nav aria-label="Page navigation">
									<ul class="pagination justify-content-center">
										<li class="page-item align-self-center">
											<a @click="loadFavorite(favorite_current_page <=0 ? 0:favorite_current_page - 1)" class="page-link" aria-label="Previous">
												<span aria-hidden="true">&laquo;</span>
												<span class="sr-only">Previous</span>
											</a>
										</li>
										<li v-for="(page,index) in pagination" :key="index" :class="page == favorite_current_page ? 'page-item active':'page-item '"><a class="page-link" @click="loadFavorite(page)">{{page}}</a></li>
										<li class="page-item">
											<a @click="loadFavorite(favorite_current_page >= last_page ? last_page:favorite_current_page + 1)" class="page-link" aria-label="Next">
												<span aria-hidden="true">&raquo;</span>
												<span class="sr-only">Next</span>
											</a>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex';
	export default {
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				token: (state) => state.token,
				endpoint: (state) => state.endpoint,
				head: (state) => state.booking_head,
				body: (state) => state.booking_body,
			})
		},
		data() {
			return {
				loadingFavorite: false,
				favorite_current_page: 1,
				last_page: 0,
				favorites: [],
				pagination: [],
			}
		},
		methods: {
			delFavorite(id) {
				this.favorites = this.favorites.filter((d) => d.id != id);

				this.$store.dispatch('get', this.endpoint + 'remove-favorite-salon/' + id + '?token=' + this.token)
					.then((data) => {
						console.log(data);
					});
			},
			loadFavorite(page) {
				this.loadingFavorite = true;
				this.$store.state.loader = true;
				this.$store.dispatch('get', this.endpoint + 'get-favorite-salons?page=' + page + '&token=' + this.token)
					.then((data) => {
						console.log(data.data);
						this.favorites = data.data.data;
						this.favorite_current_page = data.data.current_page;
						this.last_page = data.data.last_page;
						this.pagination = [];
						for (var c = 1; c <= data.data.last_page; c++) {
							this.pagination.push(c);
						}
						this.loadingFavorite = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.loadingFavorite = false
					});

			},
		},
		created() {
			this.loadFavorite(1);
			console.log(this.favorites);
		}
	}

</script>
